<template>
  <div>
    <!-- <van-nav-bar
      :title="$route.meta.title"
      left-text="返回"
      @click-left="$router.back()"
      left-arrow
      :fixed="true"
    /> -->
    <div class="submit">
      <!-- 配送地址 -->
      <div class="ship-adress">
        <div class="dispatTime">
          <div class="explain">{{ $t("reserveType") }}</div>
          <div class="selectTim">
            <van-radio-group
              v-model="topayarr.reserveType"
              @change="handleChangeRadio"
            >
              <van-row type="flex">
                <!-- <van-col span="8">
                  <van-radio
                    name="3"
                    v-if="
                      reserver_Type == 7 ||
                      reserver_Type == 5 ||
                      reserver_Type == 6 ||
                      reserver_Type == 4
                    "
                    >{{ $t('reserveType1') }}</van-radio
                  >
                </van-col> -->
                <!-- <van-col span="8">
                  <van-radio
                    name="1"
                    v-if="
                      reserver_Type == 7 ||
                      reserver_Type == 1 ||
                      reserver_Type == 3 ||
                      reserver_Type == 5
                    "
                    >{{ $t('reserveType2') }}</van-radio
                  >
                </van-col> -->
                <van-col span="8">
                  <van-radio
                    name="2"
                    v-if="
                      reserver_Type == 7 ||
                      reserver_Type == 3 ||
                      reserver_Type == 6 ||
                      reserver_Type == 2
                    "
                    >{{ $t("storage") }}</van-radio
                  >
                </van-col>
              </van-row>
            </van-radio-group>
          </div>
        </div>
        <!-- 外卖地址 -->
        <div
          class="select-adress"
          @click="handleSelectAdress"
          v-if="topayarr.reserveType == 3 || topayarr.reserveType == ''"
        >
          <div>
            <div class="explain">{{ $t("shippingAddress") }}</div>
            <div class="selectClick" v-if="JSON.stringify(address) == '{}'">
              {{ $t("shippingAddressTip") }}
            </div>
            <div class="selectClick" v-else>{{ address.allName }}</div>
          </div>
          <img class="rightClick" src="../../assets/next.png" alt="" />
        </div>
        <!-- 店铺地址 -->
        <!-- <div
          class="select-adress"
          v-if="topayarr.reserveType == 1 || topayarr.reserveType == 2"
        >
          <div>
            <div class="explain">{{ $t("shopAddress") }}</div>
            <div class="selectClick">{{ shopAddress }}</div>
          </div>
        </div> -->
        <!-- shoujihao -->
        <!-- <div class="phone">手机号：{{ userPhone }}</div> -->
        <div class="phone">
          <van-field
            v-model="adminName"
            :placeholder="$t('nameExplain')"
            :label="$t('name') + '：'"
            @input="handleChangeName"
          />
        </div>
        <div class="phone">
          <van-field
            v-model="adminphone"
            :placeholder="$t('phoneExplain')"
            type="number"
            :label="$t('phone') + '：'"
            @blur="blurField"
            @input="handleChangePhone"
          />
        </div>
        <div class="reserveTime">
          <div>{{ $t("reserveTime") }}</div>
          <div>{{ mealPeriodTime.substring(0, 10) }}</div>
          <div>
            {{ $route.query.mealHourName }}
          </div>
        </div>
        <!-- <div
          class="select-adress"
          @click="showPicker = true"
          v-if="columns.length > 0 && topayarr.reserveType == 3"
        >
          <div>
            <div class="explain">开始配送时间</div>
            <div class="selectTim">
              {{ deliveryTime == "" ? "请选择配送时间" : deliveryTime }}
            </div>
          </div>
          <img class="rightClick" src="../../assets/next.png" alt="" />
        </div> -->
        <!-- 自提 -->
        <!-- <div
          class="checkbox-main"
          v-if="topayarr.reserveType == 2 && isSideBoard"
        >
          <van-checkbox-group
            v-model="checkboxresult"
            direction="horizontal"
            @change="handleChangeCheckbox"
          >
            <van-row type="flex" justify="space-around" style="width: 100%">
              <van-col span="12" class="dfc jcc">
                <van-checkbox shape="square" name="1">{{
                  $t("storage")
                }}</van-checkbox>
              </van-col>
              <van-col
                span="12"
                class="dfc jcc"
                v-if="!prohibitionOfSelectingLockers"
              >
                <van-checkbox shape="square" name="2">{{ $t('warm') }}</van-checkbox>
              </van-col>
            </van-row>
          </van-checkbox-group>
        </div> -->
        <!-- <div
          class="dispatTime"
          v-if="checkboxresult.includes('1') && topayarr.reserveType == 2"
        >
          <div class="explain">{{ $t("storage") }}</div>
          <div
            class="selectTim"
            :class="[foodStorageText == '' ? 'redTim' : '']"
            @click="showPickerPopup = true"
          >
            {{
              foodStorageText == "" ? $t("storageCabinetTip") : foodStorageText
            }}
          </div>
        </div> -->
        <!-- 存餐柜弹窗 -->
        <van-popup v-model="showPickerPopup" round position="bottom">
          <van-picker
            show-toolbar
            :confirm-button-text="$t('confirm')"
            :cancel-button-text="$t('orderCancel')"
            value-key="sideBoardName"
            :columns="foodColumns"
            @cancel="showPickerPopup = false"
            @confirm="onConfirmFood"
          />
        </van-popup>
      </div>
      <!-- 订单列表 -->
      <div class="order-list">
        <div class="order-explain">
          <div class="main-item" v-for="item in mealList" :key="item.id">
            <img
              :src="
                item.productpic == ''
                  ? require('../../assets/noimg.jpeg')
                  : item.productpic
              "
              alt=""
            />
            <div class="shopName">
              {{ language == "CN" ? item.name : item.nameEn || item.name }}
            </div>
            <div class="shopCount">×{{ item.count }}</div>
            <div class="shopPrice" v-if="item.price == item.vipprice">
              ￥{{ (item.price / 100).toFixed(2) }}
            </div>
            <div class="shopPrice" v-else>
              ￥{{ (item.vipprice / 100).toFixed(2) }}
            </div>
          </div>
        </div>
        <div
          class="charges"
          v-if="topayarr.reserveType == 2 || topayarr.reserveType == 3"
        >
          <div>{{ $t("packageFee") }}</div>
          <div>￥{{ (packPrice / 100).toFixed(2) }}</div>
        </div>
        <div class="charges" v-if="topayarr.reserveType == 3">
          <div>{{ $t("shippingFee") }}</div>
          <div>￥{{ (deliveryPrice / 100).toFixed(2) }}</div>
        </div>
        <div class="charges" v-if="checkboxresult.includes('1')">
          <div>{{ $t("storageFee") }}</div>
          <div>￥{{ (savePrice / 100).toFixed(2) }}</div>
        </div>
        <div class="charges" v-if="checkboxresult.includes('2')">
          <div>{{ $t("warmFee") }}</div>
          <div>￥{{ (warmPrice / 100).toFixed(2) }}</div>
        </div>
        <div class="charges" v-if="computeVipPrice != 0">
          <div>{{ $t("discountPriceFee") }}</div>
          <div class="prefe">￥{{ (computeVipPrice / 100).toFixed(2) }}</div>
        </div>
        <div class="subtotal">
          <div>{{ $t("totalFee") }}</div>
          <div>￥{{ Number(computCount / 100).toFixed(2) }}</div>
        </div>
      </div>
      <!-- 支付方式 -->
      <div class="payment">
        <div class="head">{{ $t("paymentType") }}</div>
        <van-radio-group v-model="payRadio" @change="handleClickRadio">
          <div class="pay-item" v-if="$route.query.type == 16">
            <div style="display: flex; align-items: center">
              <img src="../../assets/card.png" alt="" />
              <div>{{ $t("cardPay") }}</div>
            </div>
            <van-radio name="1" checked-color="#09BB07" />
          </div>
          <div v-if="$route.query.type == 39">
            <div class="pay-item" v-for="item in groupPayData" :key="item.id">
              <div style="display: flex; align-items: center">
                <img src="../../assets/card.png" alt="" />
                <div>{{ item.payAccountName }}</div>
              </div>
              <van-radio :name="item.id" checked-color="#09BB07" />
            </div>
          </div>

          <div class="pay-item">
            <div style="display: flex; align-items: center">
              <img src="@/assets/ic_wxpay.png" alt="" />
              <div>{{ $t('wxPay') }}</div>
            </div>
            <van-radio name="3" checked-color="#09BB07" />
          </div>
          <!-- <div class="pay-item">
            <div style="display: flex; align-items: center">
              <img src="@/assets/youhuiquan.png" alt="" />
              <div>优惠券支付</div>
            </div>
            <van-radio name="2" checked-color="#09BB07" />
          </div> -->
        </van-radio-group>
      </div>
      <!-- 订单备注 -->
      <div class="order-note">
        <van-field
          v-model="orderMessage"
          rows="4"
          maxlength="50"
          autosize
          :label="$t('orderRemark')"
          type="textarea"
          :placeholder="$t('orderRemarkTip')"
          show-word-limit
          @input="handleInput"
        />
      </div>
      <!-- 底部 -->
      <div class="footer">
        <div class="price">￥{{ Number(computCount / 100).toFixed(2) }}</div>
        <van-button class="payBtn" type="info" @click="handlePay">{{
          $t("orderSubmit")
        }}</van-button>
      </div>
      <!-- 选择配送时间 -->
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @cancel="showPicker = false"
          @confirm="onConfirm"
          @change="changePicker"
        />
      </van-popup>
      <!-- 优惠券支付 -->
      <van-dialog
        v-model="couponsShow"
        show-cancel-button
        :title="$t('selectDiscount')"
        confirmButtonColor="#419DFB"
        @confirm="handleSelectCounpons"
        @cancel="handleCancelDiolg"
      >
        <van-radio-group v-model="selectCounpons" @change="handleClickCounpons">
          <div class="counpons-main" v-if="counponsList.length">
            <div
              :class="['counpons-main-outer', 'bgImg' + item.coupon.couponType]"
              v-for="item in counponsList"
              :key="item.coupon.id"
            >
              <div>
                <div class="price" v-if="item.coupon.couponType == 1">
                  {{ parseInt(item.coupon.moneyValue / 100)
                  }}<span class="yuan">{{ $t("yuan") }}</span>
                </div>
                <div class="price" v-if="item.coupon.couponType == 2">
                  {{ parseInt(item.coupon.discount / 10)
                  }}<span class="yuan">{{ $t("fold") }}</span>
                </div>
                <div class="explan">{{ $t("noneMoney") }}</div>
              </div>
              <div class="counpons-main-outer-right">
                <div class="titlre">{{ item.coupon.name }}</div>
                <div class="explain" v-if="item.usedcondition.canUseShopIds">
                  {{ $t("section") }}
                </div>
                <div class="explain" v-else>{{ $t("common") }}</div>
                <div class="tags">
                  {{
                    item.coupon.couponType == "1"
                      ? "现金抵扣券"
                      : item.coupon.couponType == "2"
                      ? "整单折扣券"
                      : "菜品抵用券"
                  }}
                </div>
                <div class="select-main">
                  <div class="select">{{ $t("select") }}</div>
                  <van-radio :name="item" checked-color="#09BB07" />
                </div>
              </div>
            </div>
          </div>
          <div class="counpons-main nullData" v-else>{{ $t("noData") }}</div>
        </van-radio-group>
      </van-dialog>

      <van-popup
        v-model="wxPaySHowDialog"
        round
        :style="{ height: '22%', width: '80%' }"
      >
        <div class="wx-pay-counter">
          <van-icon
            name="cross"
            class="close-icon"
            color="#999"
            @click="wxPaySHowDialog = false"
          />
          <div class="explain-tips">{{ $t('noBalance') }}</div>
          <div class="control-text" @click="handleControlCombination">
            {{ $t('CombinedPayment') }} 〉〉
          </div>
        </div>
      </van-popup>
    </div>
    <div id="formValue"></div>
    <!-- 组合支付弹窗 -->
    <van-popup
      v-model="showCombinationPopup"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="combination-pay-popup-counter">
        <van-icon
          name="cross"
          class="combination-close"
          color="#999"
          @click="showCombinationPopup = false"
        />
        <div class="popup-title">{{ $t('CombinedPayment') }}</div>
        <div class="pay-money">¥{{ (computCount / 100).toFixed(2) }}</div>
        <div class="payment-main">
          <img src="../../assets/card.png" alt="" />
          <div class="pay-explain">
            <span>{{$t('cardPay')}}</span>
            <span>{{ $t('cardMoney') }} ¥{{ myBalance }}</span>
          </div>
        </div>
        <van-radio-group v-model="combinationPay">
          <div class="wx-pay-item">
            <div style="display: flex; align-items: center; gap: 12px">
              <img src="@/assets/ic_wxpay.png" alt="" />
              <div>{{ $t('wxPay') }}</div>
            </div>
            <van-radio name="1" checked-color="#09BB07" />
          </div>
        </van-radio-group>
        <div class="confirm-pay-btn" @click="handleWXPay">{{ $t('confirmPay') }}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from "vant";
import wxPay from "@/utils/wxPay";
export default {
  data() {
    return {
      defaultIndex: -1,
      payRadio: "1",
      combinationPay: "1",
      orderMessage: "",
      totalPrice: 15,
      mealList: [],
      packPrice: sessionStorage.getItem("packPrice"),
      deliveryPrice: sessionStorage.getItem("deliveryPrice"),
      mealPeriodTime: "",
      showPicker: false,
      columns: [],
      deliveryTime: "",
      address: {},
      topayarr: {
        branchId: "",
        shopId: "",
        customerId: "",
        branchName: "",
        targetDate: "",
        levelNo: "",
        addressId: "",
        orderDetails: [
          {
            productId: "",
            productName: "",
            count: 0,
          },
        ],
        note: "",
        mealHourId: "",
        mealHourName: "",
        reserveType: "2",
        meal: false,
        warm: false,
        needStore: true,
        deliveryTimeId: "",
      },
      canCardPay: true,
      payType: "1",
      storeData: [],
      shopId: "",
      balance: null,
      selectPeiT: [],
      shopAddress: "",
      reserver_Type: 0,
      userPhone: "",
      adminphone: "",
      adminName: "",
      locationId: "",
      couponsShow: false,
      verifyCode: "",
      selectCounpons: "",
      counponsList: [],
      iscounpons: {},
      groupPayData: [],
      groupPayRuleId: null,
      isSideBoard: false,
      checkboxresult: ["1"],
      prohibitionOfSelectingLockers: false,
      foodStorageText: "",
      showPickerPopup: false,
      foodColumns: [],
      savePrice: "",
      warmPrice: "",
      language: "",
      wxPaySHowDialog: false,
      orderNoD: "",
      showCombinationPopup: false,
      myBalance: 0.00
    };
  },
  computed: {
    computCount: function () {
      if (this.topayarr.reserveType == "3") {
        let count = null;
        for (let i = 0; i < this.mealList.length; i++) {
          if (this.mealList[i].price == this.mealList[i].vipprice) {
            count += this.mealList[i].count * this.mealList[i].price;
          } else {
            count += this.mealList[i].count * this.mealList[i].vipprice;
          }
        }
        count += Number(this.packPrice) + Number(this.deliveryPrice);
        return count;
      } else if (this.topayarr.reserveType == "2") {
        let count = null;
        for (let i = 0; i < this.mealList.length; i++) {
          if (this.mealList[i].price == this.mealList[i].vipprice) {
            count += this.mealList[i].count * this.mealList[i].price;
          } else {
            count += this.mealList[i].count * this.mealList[i].vipprice;
          }
        }
        count += Number(this.packPrice);
        return count;
      } else {
        let count = null;
        for (let i = 0; i < this.mealList.length; i++) {
          if (this.mealList[i].price == this.mealList[i].vipprice) {
            count += this.mealList[i].count * this.mealList[i].price;
          } else {
            count += this.mealList[i].count * this.mealList[i].vipprice;
          }
        }
        return count;
      }
    },
    computeVipPrice() {
      let price = 0;
      this.mealList.map((item) => {
        if (item.price != item.vipprice) {
          price += item.price - item.vipprice;
        }
      });
      return price;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/cial/adress") {
        vm.deliveryTime = sessionStorage.getItem("deveryValue");
        vm.topayarr.deliveryTimeId = sessionStorage.getItem("deliveryTimeId");
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/card/package" || to.path == "/order/paysuccess") {
      sessionStorage.removeItem("deveryValue");
    }
    next();
  },
  activated() {
    console.log(this.$route.query, "mealHourName==");

    this.payRadio = "1";
    if (["1069", "1132"].includes(this.$route.query.branchId)) {
      this.payRadio = "3";
    }
    this.shopId = localStorage.getItem("shopId");
    this.language = localStorage.getItem("language");
    this.locationId = localStorage.getItem("locationId");
    if (this.locationId && this.locationId != "null") {
      this.getAdressLocationId();
    }
    this.orderMessage = "";
    // this.orderMessage = localStorage.getItem("remoke") || "";
    this.userPhone = localStorage.getItem("phone");
    if (localStorage.getItem("adminPhone")) {
      this.adminphone = localStorage.getItem("adminPhone");
    }
    if (localStorage.getItem("adminName")) {
      this.adminName = localStorage.getItem("adminName");
    }
    this.storeData = [];
    this.mealList = JSON.parse(sessionStorage.getItem("mealList"));
    for (let i = 0; i < this.mealList.length; i++) {
      let a = {
        productId: "",
        productName: "",
        count: "",
        price: "",
      };
      a.productId = this.mealList[i].id;
      a.productName =
        this.language == "CN"
          ? this.mealList[i].name
          : this.mealList[i].nameEn || this.mealList[i].name;
      a.count = this.mealList[i].count;
      a.price = this.mealList[i].price;
      this.storeData.push(a);
    }
    this.topayarr.orderDetails = this.storeData;
    // if (sessionStorage.getItem("adress")) {
    //   this.address = JSON.parse(sessionStorage.getItem("adress"));
    // }
    if (localStorage.getItem("global-address")) {
      this.address = JSON.parse(localStorage.getItem("global-address"));
    }
    this.balance = (localStorage.getItem("balance") / 100).toFixed(2);
    let idd = JSON.parse(sessionStorage.getItem("selectTime"));
    this.topayarr.mealHourId = idd.id;
    this.mealPeriodTime = this.$route.query.mealPeriodTime;
    this.topayarr.branchId = this.$route.query.branchId;
    this.topayarr.shopId = localStorage.getItem("shopId");
    let roles = JSON.parse(localStorage.getItem("customerInfoList"));
    if (roles && roles[0].customerId) {
      this.topayarr.customerId = roles[0].customerId;
    } else {
      let custo = localStorage.getItem("customerId");
      this.topayarr.customerId = custo == "undefined" ? 0 : custo;
    }

    this.topayarr.branchName = this.$route.query.branchName;
    this.topayarr.targetDate = this.$route.query.mealPeriodTime.substring(
      0,
      10
    );
    this.topayarr.mealHourName = this.$route.query.mealHourName;
    this.shopAddress = sessionStorage.getItem("branchName");
    // this.getConfigType();
    this.getConfig();
    this.getTimeConfig();
    // this.getCouponsList();
    this.getGroupPay();
    this.getFoodStroageList();
    this.getSaveWarmPrice();
  },
  created() {},
  mounted() {},
  methods: {
    async getBalance() {
      let data = {
        shopId: this.shopId,
        customerId: this.topayarr.customerId,
      };
      const { data: resData } = await this.$logina.post(
        "/api/wxapp/customer/getBalanceV3",
        data
      );
      if (resData.code == 200) {
        this.myBalance = (resData.data.balance / 100).toFixed(2);
        localStorage.setItem("customerName", resData.data.customerName);
      } else {
        this.$toast(resData.message);
      }
    },
    getAdressLocationId() {
      this.$logina
        .post(
          `/api/wxapp/multiLevelCategory/query2?shopId=${this.shopId}&levelNo=${this.locationId}`
        )
        .then((res) => {
          let resData = res.data;
          if (resData.data && resData.data.length > 0) {
            this.address = resData.data[0];
          }
        });
    },
    handleInput() {
      // localStorage.setItem("remoke", this.orderMessage);
    },
    handleChangeRadio(e) {
      if (e == 1 || e == 2) {
        this.address = {};
        this.topayarr.deliveryTimeId = "";
      } else {
        // if (sessionStorage.getItem("adress")) {
        //   this.address = JSON.parse(sessionStorage.getItem("adress"));
        // }
        if (localStorage.getItem("global-address")) {
          this.address = JSON.parse(localStorage.getItem("global-address"));
        }
        if (sessionStorage.getItem("deliveryTimeId")) {
          this.topayarr.deliveryTimeId =
            sessionStorage.getItem("deliveryTimeId");
        }
      }
    },
    blurField() {
      if (!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.adminphone)) {
        this.$toast(this.$t("correctPhone"));
      }
    },
    // 判断堂食、自提、外卖类型
    // getConfigType() {
    //   const data = {
    //     shopId: this.shopId,
    //     branchId: this.$route.query.branchId,
    //   };
    //   this.$authAjax.post("/api/wxapp/reserve/allowType", data).then((res) => {
    //     const { data } = res.data;
    //     if (data && data.allowReserveType) {
    //       this.reserver_Type = data.allowReserveType;
    //     } else {
    //       this.getConfig();
    //     }
    //     const types = [];
    //     if (
    //       this.reserver_Type == 7 ||
    //       this.reserver_Type == 5 ||
    //       this.reserver_Type == 6 ||
    //       this.reserver_Type == 4
    //     ) {
    //       types.push("3");
    //       this.topayarr.reserveType = "3";
    //     }
    //     if (
    //       this.reserver_Type == 7 ||
    //       this.reserver_Type == 1 ||
    //       this.reserver_Type == 3 ||
    //       this.reserver_Type == 5
    //     ) {
    //       this.topayarr.reserveType = "1";
    //       types.push("1");
    //     }
    //     if (
    //       this.reserver_Type == 7 ||
    //       this.reserver_Type == 3 ||
    //       this.reserver_Type == 6 ||
    //       this.reserver_Type == 2
    //     ) {
    //       this.topayarr.reserveType = "2";
    //       types.push("2");
    //     }
    //     this.topayarr.reserveType = types[0];
    //   });
    // },

    getConfig() {
      let data = {
        shopId: this.shopId,
        paramName: "RESERVER_TYPE_MINI",
      };
      this.$authAjax.post("/api/shop/getShopConfig", data).then((res) => {
        let { data } = res.data;
        this.reserver_Type = data.configList[0].paramValue;
      });
    },
    handleChangeName() {
      localStorage.setItem("adminName", this.adminName);
    },
    handleChangePhone() {
      localStorage.setItem("adminPhone", this.adminphone);
    },
    handlePay() {
      if (
        !this.checkboxresult.includes("1") ||
        !this.topayarr.reserveSideBoardId
      ) {
        return this.$toast(this.$t("storageCabinetTip"));
      }
      if (this.topayarr.reserveType == "") {
        this.$toast(this.$t("reserveTypeTip"));
        return;
      } else if (
        this.topayarr.reserveType == "3" &&
        JSON.stringify(this.address) == "{}"
      ) {
        this.$toast(this.$t("shippingAddressTip2"));
        return;
      } else if (
        this.topayarr.reserveType == "3" &&
        this.columns.length > 0 &&
        !this.deliveryTime
      ) {
        this.$toast(this.$t("shippingTimeTip"));
        return;
      } else if (!this.payRadio) {
        this.$toast(this.$t("paymentTypeTip"));
        return;
      } else if (
        !this.adminphone ||
        !/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.adminphone)
      ) {
        return this.$toast(this.$t("correctPhone"));
      } else if (!this.adminName) {
        return this.$toast(this.$t("nameExplain"));
      }
      let t = this.topayarr;
      // t.addressId = this.address.id;
      t.note = this.orderMessage;
      t.levelNo = this.address.levelNo;
      t.customerName = this.adminName;
      t.customerPhone = this.adminphone;
      let resData = {
        ...t,
        orderDetailList: (t.orderDetails || []).map((item) => {
          item.productAmount = item.count;
          item.price = item.price || 0;
          return item;
        }),
        // needWarm: t.warm,
        // needStore: t.meal,
        orderType: this.$route.query.type,
      };
      let showQuit = "";
      if (localStorage.getItem("showQuit")) {
        showQuit = localStorage.getItem("showQuit");
      }
      const _this = this;
      let dialogMessage = "￥" + (this.computCount / 100).toFixed(2);

      if (["1124"].includes(`${t.branchId}`)) {
        dialogMessage += "<br/>餐厅接单后订单不可退";
      }

      var payRadio = this.payRadio;

      Dialog.alert({
        allowHtml: true,
        message: dialogMessage,
        showCancelButton: true,
        confirmButtonText: this.$t("confirmPay"),
        cancelButtonText: this.$t("orderCancel"),
        confirmButtonColor: "#419DFB",
      })
        .then(() => {
          this.$authAjax
            .post("/api/wxapp/new/reserve/order/create", resData)
            .then(async (res) => {
              if (res.data.code == 200) {
                this.canCardPay = res.data.data.canCardPay;
                this.$toast.loading({
                  message: this.$t("paymentIn"),
                  forbidClick: true,
                  loadingType: "spinner",
                });
                _this.orderNoD = res.data.data.orderNo;
                let orderNoD = res.data.data.orderNo;
                let totalMoney = res.data.data.totalMoney;
                let resD = {
                  orderNo: orderNoD,
                };

                if (this.$route.query.type == 39) {
                  let workshopData = {
                    orderNo: orderNoD,
                    groupPayRuleId: this.payRadio,
                  };
                  this.$authAjax
                    .post(
                      "/api/wxapp/new/reserve/order/group/pay",
                      workshopData
                    )
                    .then((response) => {
                      if (response.data.code == 200) {
                        this.$toast.success(this.$t("paySuccess"));
                        setTimeout(() => {
                          this.$router.replace({
                            path: "/order/paysuccess",
                            query: {
                              orderNo: orderNoD,
                              branchId: this.$route.query.branchId,
                              branchName: this.$route.query.branchName,
                              type: this.$route.query.type,
                            },
                          });
                          localStorage.setItem("remoke", "");
                        }, 1000);
                      } else {
                        this.$toast.fail(response.data.message);
                      }
                    });
                  return;
                }

                // 0 元订单 payRadio = 1
                if (totalMoney == 0) {
                  payRadio = "1";
                }

                if (payRadio == "1") {
                  this.$toast.loading({
                    message: this.$t("paymentIn"),
                    forbidClick: true,
                    loadingType: "spinner",
                  });
                  this.$authAjax
                    .post("/api/wxapp/new/reserve/order/card/pay", resD)
                    .then((req) => {
                      if (req.data.code == 200) {
                        if (req.data.data.payStatusCode == "-1") {
                          this.wxPaySHowDialog = true;
                          return;
                        }
                        this.$toast.success(this.$t("paySuccess"));
                        setTimeout(() => {
                          this.$router.replace({
                            path: "/order/paysuccess",
                            query: {
                              orderNo: orderNoD,
                              branchId: this.$route.query.branchId,
                              branchName: this.$route.query.branchName,
                              type: this.$route.query.type,
                            },
                          });
                          localStorage.setItem("remoke", "");
                        }, 1000);
                      } else {
                        this.$toast.fail(req.data.message);
                      }
                    });
                } else if (payRadio == "2") {
                  //优惠券支付
                  let obj = {
                    orderNo: orderNoD,
                    verifyCode: _this.verifyCode,
                    channelId: 2,
                    timestamp: new Date().getTime(),
                  };
                  this.$test
                    .post("/api/wxapp/new/reserve/order/coupon/pay", obj)
                    .then((res) => {
                      let { data } = res;
                      if (data.code == 200) {
                        this.$toast.success(this.$t("paySuccess"));
                        setTimeout(() => {
                          this.$router.replace({
                            path: "/order/paysuccess",
                            query: {
                              orderNo: orderNoD,
                              branchId: this.$route.query.branchId,
                              branchName: this.$route.query.branchName,
                              type: this.$route.query.type,
                            },
                          });
                          localStorage.setItem("remoke", "");
                        }, 1000);
                      } else {
                        this.$toast.fail(data.message);
                      }
                    });
                } else {
                  //微信支付
                  let openId = localStorage.getItem("wxOpenId");
                  let resDa = {
                    miniPg: false,
                    orderNo: resD.orderNo,
                    openId: openId,
                  };
                  this.$authAjax
                    .post("/api/wxapp/new/reserve/order/wx/pay", resDa)
                    .then((rec) => {
                      // console.log(rec.data);
                      rec.data.data.appId = rec.data?.data?.appId || "wx4bf1260c290f196c";
                      if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                          document.addEventListener(
                            "WeixinJSBridgeReady",
                            wxPay(rec.data.data, () => {}),
                            false
                          );
                        } else if (document.attachEvent) {
                          document.attachEvent(
                            "WeixinJSBridgeReady",
                            wxPay(rec.data.data, () => {})
                          );
                          document.attachEvent(
                            "onWeixinJSBridgeReady",
                            wxPay(rec.data.data, () => {})
                          );
                        }
                      } else {
                        wxPay(rec.data.data, () => {});
                      }

                      // 工商支付
                      // if (rec.data.data.h5Form) {
                      //   document.getElementById("formValue").innerHTML =
                      //     rec.data.data.h5Form;
                      //   document.forms[0].submit();
                      // }
                    });
                }
              } else {
                this.$toast(res.data.message);
              }
            });
        })
        .catch(() => {
          //this.$toast.success("支付成功");
          // this.$toast.fail("支付失败");
        });
    },
    getTimeConfig() {
      let data = {
        branchId: this.$route.query.branchId,
        shopId: this.shopId,
        targetDay: this.mealPeriodTime.substring(0, 10),
        mealConfigId: this.topayarr.mealHourId,
      };
      this.$authAjax
        .post("/api/wxapp/branch/List/getDeliveryTime", data)
        .then((res) => {
          let { data } = res.data;
          this.selectPeiT = data;
          this.columns = [];
          for (let i = 0; i < data.length; i++) {
            if (data[i].startTime == data[i].endTime) {
              this.columns.push(data[i].startTime);
            } else {
              this.columns.push(data[i].startTime + " - " + data[i].endTime);
            }
          }
          if (!sessionStorage.getItem("deveryValue")) {
            this.deliveryTime = this.columns[0];
            this.topayarr.deliveryTimeId = this.selectPeiT[0]?.deliveryTimeId;
            sessionStorage.setItem(
              "deliveryTimeId",
              this.topayarr.deliveryTimeId
            );
          }
        });
    },
    onConfirm(value) {
      this.deliveryTime = value;
      this.showPicker = false;
    },
    changePicker(picker, value, index) {
      this.topayarr.deliveryTimeId = this.selectPeiT[index].deliveryTimeId;
      sessionStorage.setItem("deliveryTimeId", this.topayarr.deliveryTimeId);
      sessionStorage.setItem("deveryValue", value);
    },
    //选择地址
    handleSelectAdress() {
      this.$router.push({
        path: "/cial/adress",
        query: {
          mealPeriodTime: this.$route.query.mealPeriodTime,
          mealHourName: this.$route.query.mealHourName,
          mealHourTime: this.$route.query.mealHourTime,
          branchId: this.$route.query.branchId,
          branchName: this.$route.query.branchName,
        },
      });
    },
    // 获取存餐柜列表
    getFoodStroageList() {
      let data = {
        branchId: this.$route.query.branchId,
        shopId: this.shopId,
      };
      this.$authAjax
        .post("/api/wxapp/aiyouwei/getSideBoardsByConfig", data)
        .then((res) => {
          let { data } = res;
          if (data.code == 200) {
            this.isSideBoard = true;
            this.foodColumns = data.data;
            this.topayarr.reserveSideBoardId = data.data.length && data.data[0].id;
          }
        });
    },
    //存餐柜
    onConfirmFood(e) {
      this.showPickerPopup = false;
      this.foodStorageText = e.sideBoardName;
      this.topayarr.reserveSideBoardId = e.id;
    },
    handleChangeCheckbox(e) {
      console.log(e, "ee");

      if (e.includes("1")) {
        this.topayarr.needStore = true;
      } else {
        this.topayarr.needStore = false;
        this.foodStorageText = "";
        this.topayarr.reserveSideBoardId = "";
      }
      if (e.includes("2")) {
        this.topayarr.needWarm = true;
      } else {
        this.topayarr.needWarm = false;
      }
    },
    //获取存餐费和加热费用
    getSaveWarmPrice() {
      let data = {
        branchId: this.$route.query.branchId,
        shopId: this.shopId,
      };
      this.$authAjax
        .post("/api/wxapp/branch/getMealsPriceAndWarmPrice", data)
        .then((res) => {
          let { data } = res;
          if (data.code == 200) {
            this.savePrice = data.data.savePrice || 0;
            this.warmPrice = data.data.warmPrice || 0;
          }
        });
    },
    //获取优惠券列表
    getCouponsList() {
      let obj = {
        channelId: 2,
        shopId: this.shopId, //this.shopId,23
        status: 1,
        timestamp: new Date().getTime(),
        userId: this.topayarr.customerId.toString(),
        // userId: "2761965",
        userName: localStorage.getItem("userName"), //localStorage.getItem("userName")"游客_111",
      };
      this.$test.post("/api/coupons/v1/usercoupons", obj).then((res) => {
        let { data } = res;
        if (data.code == 200) {
          this.counponsList = data.data;
        }
      });
    },
    //优惠券
    handleClickRadio(e) {
      if (e == 2) {
        this.couponsShow = true;
      }
    },
    //
    handleSelectCounpons() {
      let data = {
        channelId: 2,
        shopId: this.shopId,
        status: 1,
        timestamp: new Date().getTime(),
        userId: this.topayarr.customerId.toString(),
        // userId: '2714352',
        userName: localStorage.getItem("userName"), //"游客_111",
        couponUserItemId: this.iscounpons.couponuser.id,
        validSecond: 600000,
      };
      this.$test.post("/api/coupons/v1/verifycode", data).then((res) => {
        let { data } = res;
        if (data.code == 200) {
          this.verifyCode = data.data.couponuser.verifyCode;
        } else {
          this.$toast(data.message);
        }
      });
      this.selectCounpons = "";
    },
    handleCancelDiolg() {
      this.selectCounpons = "";
    },
    handleClickCounpons(item) {
      this.iscounpons = item;
    },

    // 获取挂帐账号
    getGroupPay() {
      this.$authAjax
        .get("/api/wxapp/customer/groupPayAccount/list")
        .then((res) => {
          let { data } = res.data;
          this.groupPayData = data;
        });
    },
    // 微信支付
    handleWXPay() {
      let openId = localStorage.getItem("wxOpenId");
      let resDa = {
        miniPg: false,
        orderNo: this.orderNoD,
        openId: openId,
      };
      this.$authAjax
        .post("/api/wxapp/new/reserve/order/wx/pay", resDa)
        .then((rec) => {
          console.log(rec.data);
          rec.data.data.appId = rec.data?.data?.appId || "wx4bf1260c290f196c";
          this.showCombinationPopup = false;
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                wxPay(rec.data.data, () => {}),
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent(
                "WeixinJSBridgeReady",
                wxPay(rec.data.data, () => {})
              );
              document.attachEvent(
                "onWeixinJSBridgeReady",
                wxPay(rec.data.data, () => {})
              );
            }
          } else {
            wxPay(rec.data.data, () => {});
          }

          // // 工商支付
          // if (rec.data.data.h5Form) {
          //   document.getElementById("formValue").innerHTML =
          //     rec.data.data.h5Form;
          //   document.forms[0].submit();
          // }
        });
    },
    // 组合支付
    handleControlCombination() {
      this.wxPaySHowDialog = false;
      this.showCombinationPopup = true;
      this.getBalance();
    },
  },
};
</script>

<style lang="scss" scoped>
.submit {
  width: 100%;
  height: calc(100vh - 50px);
  background: #f2f2f2;
  // margin-top: 45px;
  box-sizing: border-box;
  overflow: auto;
  //配送地址
  .ship-adress {
    width: 95%;
    min-height: 30%;
    background: #fff;
    margin: 2% auto 0 auto;
    border-radius: 7px;
    padding: 10px;
    box-sizing: border-box;

    .select-adress {
      margin-left: 3%;
      padding: 10px;
      border-bottom: 1px solid #f4f5f6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .explain {
        font-size: 12px;
      }
      .selectClick {
        margin-top: 6px;
        font-size: 16px;
        font-weight: bold;
      }
      .selectTim {
        margin-top: 6px;
        font-size: 15px;
        font-weight: bold;
      }
    }
    .checkbox-main {
      padding: 15px 20px;
      font-size: 14px;
      margin-left: 3%;
      border-bottom: 1px solid #f4f5f6;
    }
    .rightClick {
      width: 10px;
      height: 10px;
      img {
        width: 10px;
        height: 10px;
      }
    }
    .phone {
      font-size: 12px;
      margin-left: 3%;
      border-bottom: 1px solid #f4f5f6;
      // padding: 10px;
      text-align: center;
    }
    .reserveTime {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 3%;
      border-bottom: 1px solid #f4f5f6;
      padding: 10px;
      font-size: 12px;
    }
    .dispatTime {
      margin-left: 3%;
      padding: 10px;
      border-bottom: 1px solid #f4f5f6;
      .explain {
        font-size: 12px;
      }
      .selectTim {
        margin-top: 6px;
        font-size: 15px;
        font-weight: bold;
      }
      .redTim {
        color: red;
        font-weight: 400;
      }
    }
    .select-time {
      display: flex;
    }
  }
  //订单列表
  .order-list {
    width: 95%;
    min-height: 25%;
    background: #fff;
    margin: 2% auto 0 auto;
    border-radius: 7px;
    padding: 10px;
    box-sizing: border-box;
    .order-explain {
      margin-left: 3%;
      border-bottom: 1px solid #f4f5f6;
      padding: 10px;
      .main-item {
        height: 50px;
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 5px;
        img {
          width: 50px;
          height: 50px;
          flex: 2;
          border-radius: 5px;
        }
        .shopName {
          margin-left: 2px;
          flex: 4;
        }
        .shopCount {
          flex: 2;
        }
        .shopPrice {
          font-weight: bold;
          font-size: 14px;
          flex: 2;
        }
      }
    }
    .charges {
      font-size: 12px;
      margin-left: 3%;
      border-bottom: 1px solid #f4f5f6;
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .prefe {
        color: #e86e31;
        text-decoration: line-through;
      }
    }
    .subtotal {
      margin-left: 3%;
      padding: 10px;
      display: flex;
      align-items: center;
      font-size: 16px;
      justify-content: flex-end;
      div:nth-child(2) {
        font-weight: 900;
      }
    }
  }
  //支付方式
  .payment {
    width: 95%;
    min-height: 15%;
    background: #fff;
    margin: 2% auto 0 auto;
    border-radius: 7px;
    padding: 10px;
    box-sizing: border-box;
    .head {
      font-size: 15px;
      font-weight: bold;
      padding: 10px 12px;
    }
    .pay-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      margin-left: 3%;
      border-bottom: 1px solid #f4f5f6;
      padding: 10px;
      img {
        width: 21px;
        height: 21px;
      }
      div {
        margin-left: 6px;
        font-size: 12px;
        font-weight: bold;
        // flex: 1;
      }
    }
  }
  //订单备注
  .order-note {
    width: 95%;
    min-height: 35%;
    background: #fff;
    margin: 2% auto 0 auto;
    border-radius: 7px;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 5px;
  }
  //底部
  .footer {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    z-index: 1000;
    height: 48px;
    padding: 6px 12px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 -2px 6px #eee;
    box-sizing: border-box;
    .price {
      margin-left: 18px;
    }
    .payBtn {
      height: 30px;
      border-radius: 3px;
      line-height: 30px;
    }
  }
  //优惠券
  .counpons-main {
    padding: 10px;
    height: 170px;
    overflow: auto;
    .bgImg1 {
      background: url("../../assets/counpons.png");
    }
    .bgImg2 {
      background: url("../../assets/Group 15490.png");
    }
    .bgImg3 {
      background: url("../../assets/Group 15491.png");
    }
    .bgImg4 {
      background: url("../../assets/Group 15492.png");
    }

    &-outer {
      width: 100%;
      height: 100px;
      // background: url("../../assets/counpons.png");
      background-size: cover;
      margin-top: 10px;
      position: relative;
      overflow: auto;
      display: flex;
      .price {
        font-size: 30px;
        font-weight: bold;
        line-height: 56px;
        color: #ab7b4c;
        margin: 14px 0 0 8px;
        .yuan {
          font-size: 10px;
          font-weight: 500;
          line-height: 14px;
        }
      }
      .explan {
        font-size: 12px;
        font-weight: 500;
        line-height: 14px;
        margin: 2px 0 0 15px;
        color: #ab7b4c;
      }
      &-right {
        margin-left: 40px;
        width: 60%;
        .titlre {
          font-size: 17px;
          font-weight: 400;
          color: #70350a;
          line-height: 20px;
          margin-top: 14px;
        }
        .explain {
          font-size: 12px;
          font-weight: 400;
          color: #b87a40;
          line-height: 14px;
        }
        .tags {
          width: 68px;
          height: 18px;
          background: #e33f35;
          padding: 0 4px;
          box-sizing: border-box;
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          line-height: 18px;
          margin-top: 6px;
        }
        .select-main {
          display: flex;
          align-items: center;
          margin-left: 60%;
          .select {
            color: #000000;
            font-size: 14px;
            margin-right: 5px;
          }
        }
      }
    }
  }
  .nullData {
    text-align: center;
    line-height: 160px;
    color: red;
  }
}
.wx-pay-btn {
  width: 220px;
  padding: 12px 0;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: #4187f2;
  border-radius: 6px;
  margin: 20px auto;
}
#formValue {
  display: none;
}
.wx-pay-counter {
  padding: 12px;
  box-sizing: border-box;
  position: relative;
  .close-icon {
    position: absolute;
    right: 12px;
    top: 12px;
  }
  .explain-tips {
    text-align: center;
    margin-top: 20px;
    font-size: 20px;
  }
  .control-text {
    text-align: center;
    color: #167afb;
    font-size: 16px;
    margin-top: 24px;
  }
}
.combination-pay-popup-counter {
  padding: 16px;
  box-sizing: border-box;
  position: relative;
  .combination-close {
    position: absolute;
    right: 16px;
    top: 16px;
  }
  .popup-title {
    text-align: center;
    font-size: 18px;
  }
  .pay-money {
    text-align: center;
    margin-top: 24px;
    font-size: 26px;
  }
  .payment-main {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 16px 12px;
    border-bottom: 1px solid #eee;
    img {
      width: 36px;
      height: 42px;
    }
    .pay-explain {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      span {
        font-size: 15px;
        font-weight: 400;
        color: #333;
      }
    }
  }
  .wx-pay-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    padding: 10px;
    img {
      width: 32px;
      height: 32px;
    }
    div {
      font-size: 15px;
      font-weight: 400;
      color: #333;
    }
  }
  .confirm-pay-btn {
    width: 321px;
    padding: 12px 0;
    text-align: center;
    border-radius: 50px;
    background: #167afb;
    color: #fff;
    font-size: 14px;
    margin: 32px auto auto;
  }
}
</style>
